import { G2S } from '../g2s';
import * as api from '../api';

export class BestPriceService {
    getSubscriptions(request: api.BestPriceGetSubscriptionsRequest): Promise<api.BestPriceGetSubscriptionsResult> {
        return new Promise<api.BestPriceGetSubscriptionsResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/BestPrice/GetSubscriptions',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    response.data.subscriptions = response.data.subscriptions.map(s => {
                        s.dateOutward = new Date(s.dateOutward);
                        s.dateReturn = s.dateReturn && new Date(s.dateReturn);
                        return s;
                    });

                    resolve(<api.BestPriceGetSubscriptionsResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    subscribe(request: api.BestPriceSubscribeRequest): Promise<api.BestPriceSubscribeResult> {
        return new Promise<api.BestPriceSubscribeResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/BestPrice/Subscribe',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.BestPriceSubscribeResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    unsubscribe(request: api.BestPriceUnsubscribeRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/BestPrice/Unsubscribe',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function () {
                    resolve();
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
